import React from "react";

const Title = () => {
  return (
    <div className="title">
      <h2>todo list srikanth</h2>
      <div className="underline"></div>
    </div>
  );
};

export default Title;
